import PageHeader from 'components/common/PageHeader';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Profile } from '../gestionarUsuarios/components/editPage/Profile';
import classNames from 'classnames';
import { getCollabById } from 'redux/colabsSlice';

const ProfilePage = () => {
  const userLogged = useSelector(state => state.login.currentUser);
  const colab = useSelector(state => state.colabs.colab);

  const user = {
    ...colab,
    fullname: `${colab?.firstName} ${colab?.lastName}`
  };

  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    if (userLogged) {
      dispatch(getCollabById(userLogged.id, setLoading));
    }
  }, [userLogged]);

  return (
    <div
      className={classNames({
        'loading-skeleton': loading
      })}
    >
      <PageHeader
        title={user?.fullname || ''}
        description="Edite sus datos personales y su contraseña."
        className="mb-3 bg-white"
      />

      <Profile userLogged={userLogged} user={user} />
    </div>
  );
};

export default ProfilePage;
